export default "__VITE_ASSET__CYGTvTJ1__"